 // import Swiper JS
 import Swiper, {Autoplay, Pagination} from 'swiper';
 // import Swiper styles
 import 'swiper/css';
 import 'swiper/css/pagination';

 // configure Swiper to use modules
 Swiper.use([Autoplay, Pagination]);


 export function initSingleTabbedSlider() {
  if (window.acf) {
      window.acf.addAction(
        'render_block_preview/type=card-tall-carousel',
        singleTabbedSlider
      );
  }
}

export function singleTabbedSlider() {
  let singleTabbed = document.querySelector('.single-tabbed-slider');
  if (!singleTabbed)
    return;

  const swiperSingleTabbed = new Swiper('.single-tabbed-slider .swiper', {
    // Optional parameters
    direction: 'horizontal',
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    // },
    speed: 500,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 32,
    loop: false,
    grabCursor: true,
    keyboardControl: true,
    centeredSlides: true,
    pagination: false
  });

  //Find the tabs and add listeners to transition the slider
  let tabs = singleTabbed.querySelectorAll('.tabbed-tab');

  [...tabs].forEach(function (el) {;
    el.addEventListener('click', (e) => {
      removeClasses(tabs);
      swiperSingleTabbed.slideTo(e.currentTarget.getAttribute('data-tab'));
      el.classList.add('border-b-8', 'border-b-mc-blue', 'text-mc-blue', 'font-semibold');
    })

  });

  //Set up the prev/next buttons
  let nav = singleTabbed.querySelectorAll('.single-tab-nav');

  [...nav].forEach(function(el) {
    el.addEventListener('click', (e) => {
      if (e.currentTarget.getAttribute('data-direction') == 'next') {
        swiperSingleTabbed.slideNext()
      } else {
        swiperSingleTabbed.slidePrev()
      }

      //Reset the tabs at the top
      removeClasses(tabs);
      //And set to the current index
      tabs[swiperSingleTabbed.realIndex].classList.add('border-b-8', 'border-b-mc-blue', 'text-mc-blue', 'font-semibold');

    })

  })

}


function removeClasses(els) {
  for (var i = 0; i < els.length; i++) {
    els[i].classList.remove('border-b-8', 'border-b-mc-blue', 'text-mc-blue', 'font-semibold')
  }
}
